import { CustomFieldDataTypeItem } from './CustomFieldDataTypeItem'

export const Text = new CustomFieldDataTypeItem({
  id: 'd5922360-1615-47ea-bc1d-cc609e881d41',
  name: 'Text',
  description: 'A simple text field',
  dataType: 'string',
})
export const Date = new CustomFieldDataTypeItem({
  id: '2f3fecb4-c607-4c38-9a81-c5baa969c6cf',
  name: 'Date',
  description: 'A date selector',
  dataType: 'Date',
})
export const Number = new CustomFieldDataTypeItem({
  id: 'dde7b8a8-52ea-4f37-8acc-3ed7b680c1f9',
  name: 'Number',
  description: 'a simple number field',
  dataType: 'number',
})
export const Entity = new CustomFieldDataTypeItem({
  id: 'e33be1eb-f0a2-4f9c-bd01-e93613e3e750',
  name: 'Record Link',
  description: 'a hyperlink from one supported record to another in CIMS',
  dataType: 'EntityCustomFieldValue',
})
export const Report = new CustomFieldDataTypeItem({
  id: '5f82a263-31a9-45fb-8719-64b20a0facb2',
  name: 'Report',
  description:
    'a hyperlink to generate and download a specific report on demand',
  dataType: 'ReportCustomFieldValue',
})
export const List = new CustomFieldDataTypeItem({
  id: 'f0c204af-c8ec-4ca5-a284-695af2701d84',
  name: 'List',
  description: 'a dropdown, or set of checkboxes, with pre-defined text values',
  dataType: ['ListCustomFieldValue', 'BooleanListCustomFieldValue'],
})
export const Boolean = new CustomFieldDataTypeItem({
  id: '45ce0f16-3007-4a56-9a59-6288cdec1985',
  name: 'Checkbox',
  description: 'a simple checkbox',
  dataType: 'boolean',
})
